// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__11spv","detailsBorder":"styles_detailsBorder__2hUuT"};